
import { mapGetters } from 'vuex'
export default {
    props: {
        cost: {
            default: 1000,
            type: Number,
        },
        id: {
            default: '1',
            type: String,
        },
        color: {
            default: 'grey',
            type: String,
        }
    },
    data(){
        return{
            keyUK: process.env.STRIPE_PUBLISHABLE_KEY_UK,
        }
    },
    computed: {
        ...mapGetters({
            priceLabel: 'cart/getPriceLabel',
            detectedCountry: 'geolocation/detectedCountry',
        }),
    },
    mounted() {
        // First check if the script already exists on the dom
        // by searching for an id
        // Only do this if currency is GBP
        // if(this.priceLabel === 'TEFLORG'){
            const id = 'stripe'
            if(document.getElementById(id) === null) {
                const script = document.createElement('script')
                script.setAttribute('src', 'https://js.stripe.com/v3/')
                script.setAttribute('id', id)
                script.setAttribute('data-hid', id)
                document.body.appendChild(script) 

                // now wait for it to load...
                script.onload = () => {
                    // script has loaded, you can now use it safely
                    // alert('thank me later')
                    this.clearPayMessage(this.id)
                    // ... do something with the newly loaded script
                }      
            } else {
                const stripeScriptElement = document.querySelector("script[src^='https://js.stripe.com/v3']");
                if (stripeScriptElement) {
                    stripeScriptElement.addEventListener("load", () => {
                        this.clearPayMessage(this.id)
                    });
                }
            }
        // }
    },
    methods: {
        clearPayMessage(id){
            const black = 'rgb(0, 0, 0)';
            const grey = 'rgb(50, 50, 50)';
            const blue = 'rgb(57, 86, 116)';
            const white = 'rgb(255, 255, 255)';
            const currency = this.$nuxt.$options.filters.currencyCodeFromLabel()
            const appearance = {
                variables: {
                    colorText: this.color === 'grey' ? black : white,
                    colorTextSecondary: this.color === 'grey' ? grey : white, // "Learn more" text color
                    colorBackground: this.color === 'grey' ? white : blue,
                }
            };
            const key = this.keyUK
            const stripe = window.Stripe(key);
            const elements = stripe.elements({appearance});

            const options = {
                amount: +(this.cost*100).toFixed(2),
                paymentMethodTypes: ['klarna'],
                currency,
                countryCode: currency === 'EUR' ? 'IE' : 'GB'
            };

            console.log('KLARNA: ', options)

            const afterpayClearpayMessageElement =
            elements.create('paymentMethodMessaging', options);
            afterpayClearpayMessageElement.mount('#afterpay-clearpay-message-'+id);
        }
    },
}
